import { FC, Fragment } from "react";

interface AccessModeCellProps {
  isPublic: boolean;
}

export const AccessModeCell: FC<AccessModeCellProps> = ({ isPublic }) => {
  return <Fragment>{isPublic ? "Public" : "Private"}</Fragment>;
};
